import React from 'react';
import { BiCopyright } from 'react-icons/bi';

import { useToggle } from 'hooks/useToggle';
import { clickable } from 'utils/a11y';

import { ModalPrivacyPolicy } from 'components/modal-privacy-policy/modal-privacy-policy.component';

import logoImg from 'assets/logos/logo_branco.png';

import { CopyrightBox, InfoBox, FooterContainer } from './footer.styles';

export const Footer = () => {
  const [showModalPrivacy, toggleModalPrivacy] = useToggle();

  const year = () => {
    return String(new Date().getFullYear());
  };

  return (
    <FooterContainer>
      <ModalPrivacyPolicy show={showModalPrivacy} toggle={toggleModalPrivacy} />
      <InfoBox>
        <img src={logoImg} alt="EnergyPass" />

        <ul>
          <li>
            {/* Out/2026: apontava para "#" (não levava a lugar nenhum) */}
            <a href="mailto:suporte@energypass.com.br">Fale com o EnergyPass</a>
          </li>
          <li>
            <a
              href="https://www.energypass.com.br"
              target="_blank"
              rel="noreferrer"
            >
              Sobre Nós
            </a>
          </li>
          <li>
            <a
              href="https://energypass.solsticioenergia.com/lista_de_espera_energypass-0"
              target="_blank"
              rel="noreferrer"
            >
              Indique o EnergyPass
            </a>
          </li>
          <li>
            <span {...clickable(toggleModalPrivacy)}>
              Política de Privacidade
            </span>
          </li>
        </ul>
      </InfoBox>
      <CopyrightBox>
        <span>
          {' '}
          <BiCopyright /> {year()}{' '}
          <a
            href="https://www.solsticioenergia.com/"
            target="_blank"
            rel="noreferrer"
          >
            Grupo Solstício Energia.
          </a>{' '}
          Todos os direitos reservados.
        </span>
        <span>v1.3.2-b.1</span>
      </CopyrightBox>
    </FooterContainer>
  );
};
